import { render } from "./TwoFactorDeactivationModal.vue?vue&type=template&id=407a2a81"
import script from "./TwoFactorDeactivationModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorDeactivationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Solstice-Web/Solstice-Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__